module.exports = __webpack_public_path__ + "static/media/vann.1b23cbbb.m4a";